import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { isFeatureEnabled } from 'owa-feature-flags';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let ActionConfirmationsOption: LazyOption = createLazyOption(
    {
        key: 'actionNotifications',
        titleStringKey: 'optionTitle_actionConfirmations',
        searchTermsStringKey: 'optionTitle_actionConfirmations',
        isHidden: () => !isFeatureEnabled('tri-notificationBar'),
    },
    lazyFullModule,
    m => m.default
);
export default ActionConfirmationsOption;
